import {StringUtil} from "./StringUtil";

interface Base10ToStringWork {
    computedString: string;
    remainingNumber: number;
}

const PlatformBaseChars = "RiOmqcA2Y0Hof4WjThMuDL7lUgpVaXkZ1twPx9KIGJFE6SvCeNz5bBd3Qy8rn";

class BaseConverter {
    private BaseChars: string;
    private BaseLength: number;
    private PadSeparatorChar: string;
    private MinPadLength: number;
    private PadSampleStrLength: number;

    constructor(baseChars: string, minPadLength: number, padSeparator: string, padSampleStrLength: number) {
        this.BaseChars = baseChars;
        this.BaseLength = baseChars.length;
        this.PadSeparatorChar = padSeparator;
        this.MinPadLength = minPadLength;
        this.PadSampleStrLength = padSampleStrLength;
    }

    static bcInt = BaseConverter.createIntConverter();
    static bcLong = BaseConverter.createLongConverter();

    static createIntConverter(): BaseConverter {
        return new BaseConverter(
            PlatformBaseChars,
            6,
            "s",
            9);
    }

    static createLongConverter(): BaseConverter {
        return new BaseConverter(
            PlatformBaseChars,
            11,
            "s",
            15);
    }

    private fromBase10(remainingNumber: number, computedString: string): Base10ToStringWork {
        const indexFromModulo = remainingNumber % this.BaseLength;
        const newComputedString = computedString + this.BaseChars[indexFromModulo];
        const newRemainingNumber = Math.floor(remainingNumber / this.BaseLength);
        return {computedString: newComputedString, remainingNumber: newRemainingNumber};
    }

    private getNonPaddedStr(initialNumber: number): string {
        let computedString = "";
        let remainingNumber = initialNumber;
        if(initialNumber > 0) {
            while (remainingNumber > 0) {
                const result = this.fromBase10(remainingNumber, computedString);
                remainingNumber = result.remainingNumber;
                computedString = result.computedString;
            }
            const nonPaddedStr = StringUtil.reverse(computedString);
            return nonPaddedStr;
        } else {
            return "0";
        }
        // const paddedStr = StringUtil.padStart(nonPaddedStr, this.LeadingChar, this.MinPadLength);
        // return paddedStr;

    }

    private getDeterministicPadStr(input: number, padLength: number): string {
        const inputNumberStr = input.toString();
        let padNumberStr = "";
        let padBaseStr = "";
        while (padBaseStr.length < padLength) {
            for (let i = 0; i < this.PadSampleStrLength; i++) {
                const inputNumberStrIndex = i % inputNumberStr.length;
                padNumberStr += inputNumberStr[inputNumberStrIndex];
            }
            padBaseStr += this.getNonPaddedStr(parseInt(padNumberStr));
        }
        //const padBaseStr = this.getNonPaddedStr(parseInt(padNumberStr));
        const padBaseStrTruncated = padBaseStr.substr(0, padLength);
        return padBaseStrTruncated;
    }

    getStr(initialNumber: number): string {
        const nonPaddedStr = this.getNonPaddedStr(initialNumber);
        if (nonPaddedStr.length < this.MinPadLength) {
            const numOfCharsToPad = this.MinPadLength - nonPaddedStr.length;
            const padStr = numOfCharsToPad > 1 ? this.getDeterministicPadStr(initialNumber, numOfCharsToPad - 1) + this.PadSeparatorChar : this.PadSeparatorChar;
            return padStr + nonPaddedStr;
        } else {
            return nonPaddedStr
        }
        // const paddedStr = StringUtil.padStart(nonPaddedStr, this.LeadingChar, this.MinPadLength);
        // return paddedStr;
    }

    private toBase10(input: String): number {
        let computedNumber = 0;
        for (let i = input.length - 1; i >= 0; i--) {
            const baseCharIndex = this.BaseChars.indexOf(input[i]);
            const power = i;
            computedNumber += (baseCharIndex * Math.pow(this.BaseLength, power))
        }
        return computedNumber;
    }

    getNum(input: string): number {
        let nonPaddedInput = input;
        const inputParts = input.split(this.PadSeparatorChar);
        if (inputParts.length == 2) {
            nonPaddedInput = inputParts[1];
        }
        // const match = this.LeadingCharRegex.exec(input);
        // if(match && match.length == 2){
        //     nonPaddedInput = match[1];
        // }
        const nonPaddedStr = StringUtil.reverse(nonPaddedInput);
        return this.toBase10(nonPaddedStr);
    }
}

const bcInt = BaseConverter.bcInt;
const bcLong = BaseConverter.bcLong;

export {BaseConverter, bcInt, bcLong}
